<dx-select-box
  valueExpr="field"
  label="{{ 'Feld' | translate }}"
  width="100%"
  placeholder="{{ 'Feld auswählen' | translate }}"
  [displayExpr]="getFieldDisplayExpr"
  [showClearButton]="true"
  [items]="fieldList"
  [searchEnabled]="true"
  [(value)]="pimField.field"
  (onSelectionChanged)="update()"
/>

<dx-select-box
  valueExpr="id"
  label="{{ 'FeatureSystem' | translate }}"
  width="100%"
  placeholder="{{ 'FeatureSystem auswählen' | translate }}"
  displayExpr="name"
  [showClearButton]="true"
  [acceptCustomValue]="true"
  [searchEnabled]="true"
  [items]="validFeatureSystems"
  [(selectedItem)]="selectedValidFeatureSystem"
  [(value)]="pimField.systemKey"
  (onSelectionChanged)="onValidFeatureSystemChanged($event)"
/>

<dx-switch *ngIf="!isFeatureSystemOnly && selectedValidFeatureSystem?.id"
           style="margin-left: 25px; align-self: center;"
           [(value)]="pimField.useSequence"
           (onValueChanged)="update()"
/>


<dx-select-box
  *ngIf="!isFeatureSystemOnly && selectedValidFeatureSystem?.id && !pimField.useSequence"
  valueExpr="id"
  label="{{ 'Feature' | translate }}"
  width="100%"
  placeholder="{{ 'Feature auswählen' | translate }}"
  displayExpr="name"
  [showClearButton]="true"
  [acceptCustomValue]="true"
  [searchEnabled]="true"
  [items]="validFeatures"
  [(selectedItem)]="selectedValidFeature"
  [(value)]="pimField.elementKey"
  (onSelectionChanged)="update()"
/>

<dx-number-box *ngIf="!isFeatureSystemOnly && selectedValidFeatureSystem?.id && pimField.useSequence"
               class="flex-grow-1 np-highlight"
               label="{{ (pimField.useSequence ? 'Reihenfolgennummer' : 'Sortiernummer') | translate }}"
               [value]="parseInt(pimField.elementKey)"
               (onValueChanged)="onOrderChanged($event)"
/>
